import consumer from "./consumer"

export function subscribeToDocumentProcessingJobs(teamId, callbacks = {}) {
  const subscription = consumer.subscriptions.create(
    {
      channel: "DocumentProcessingJobChannel",
      team_id: teamId
    },
    {
      initialized() {},

      connected() {
        if (callbacks?.connected) callbacks.connected();
      },

      disconnected() {
        if (callbacks?.disconnected) callbacks.disconnected();
      },

      rejected() {
        if (callbacks?.rejected) callbacks.rejected();
      },

      received: function(data) {
        if (callbacks?.received) callbacks.received(data);
      }
    }
  );

  return subscription;
}
